module.exports = __webpack_public_path__ + "static/media/Q.45261a60.svg";